import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { TextField, TextArea, SelectField } from "../components/inquiries/FormFields";
import { useInquiryForm } from "../hooks/useInquiryForm";
import { Seo } from "../components/Seo";

const PROJECT_TYPES = ["Residential", "Hospitality", "Workplace", "Media Inquiry", "Other"];
const NDA_OPTIONS = ["Yes", "No"];

export default function Inquiries() {
  const { form, set, submit } = useInquiryForm();

  return (
    <div className="mp-paper min-h-screen flex flex-col" data-testid="inquiries-page">
      <Seo page="inquiries" />
      <Nav theme="light" />
      <main className="flex-1 max-w-[1600px] w-full mx-auto px-6 md:px-10 pt-10 md:pt-16">
        <h1 className="font-display font-light text-[34px] md:text-[42px] leading-[0.95] tracking-tight mp-fade">Inquiries</h1>
        <p className="max-w-xl mt-6 text-[#5f5a50] text-[14px] md:text-[15px] leading-relaxed font-light mp-fade" style={{ animationDelay: "0.1s" }}>
          Every project begins with a conversation. Tell us a little about what you have in mind and we&rsquo;ll be in touch.
        </p>

        <form onSubmit={submit} data-testid="inquiry-form" className="grid md:grid-cols-2 gap-x-12 gap-y-8 mt-16 max-w-4xl pb-24">
          <TextField id="name" label="Name *" value={form.name} onChange={(v) => set("name", v)} placeholder="Your name" />
          <TextField id="email" label="Email *" type="email" value={form.email} onChange={(v) => set("email", v)} placeholder="you@email.com" />
          <TextField id="phone" label="Phone" value={form.phone} onChange={(v) => set("phone", v)} placeholder="+971" />
          <TextField id="address" label="Address" value={form.address} onChange={(v) => set("address", v)} placeholder="Street address" />
          <TextField id="region" label="State / Country" value={form.region} onChange={(v) => set("region", v)} />
          <SelectField id="type" label="Project Type" value={form.type} onChange={(v) => set("type", v)} options={PROJECT_TYPES} placeholder="Select a type" />
          <SelectField id="nda" label="NDA Required?" value={form.nda} onChange={(v) => set("nda", v)} options={NDA_OPTIONS} placeholder="Select" />
          <TextArea id="about" label="About the Project" value={form.about} onChange={(v) => set("about", v)} placeholder="Tell us a little about what you have in mind…" className="md:col-span-2" />
          <div className="md:col-span-2">
            <button type="submit" data-testid="inquiry-submit-button" className="inline-flex items-center gap-2 bg-[#23211c] text-[#f2efe7] px-9 py-4 font-label text-[11px] hover:bg-[#3d3a33] transition-colors">
              Send Inquiry
            </button>
          </div>
        </form>
      </main>
      <Footer theme="light" />
    </div>
  );
}
